import { QRCodeCanvas } from 'qrcode.react';
import { Typography } from 'antd';
import { t } from '@/global';
import styles from './tfa.less';
const makeTitleStep1 = () => <div className={styles.subtitle}>{t('1. Download an authenticator app')}</div>;

const makeSubDescriptionStep1 = () => <>
    <div className={styles.desc}>
        {t('Download an authenticator app such as')}
        &nbsp;
        <a target={'https://authy.com/'}>Authy</a>,&nbsp;
        <a target={'https://www.microsoft.com/en-us/security/mobile-authenticator-app/'}>Microsoft</a>
        &nbsp;{t('or')}&nbsp;
        <a target={'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2/'}>Google</a>
        &nbsp;
        {t('Authenticator')}
        &nbsp;
        {t('on your phone or desktop.')}

    </div>
</>;

const makeTitleStep2 = () => <div className={styles.subtitle}>{t('2. Scan the QR code')}</div>;
export const makeSubDescriptionStep2 = () => (
    <div className={styles.desc}>
        {t('Open your authenticator app, scan the QR code and enter the code that your app shows.')}
    </div>
);



const getSecretFromUrl = (otpauthUrl: string) => {
    const secretRegex = /secret=([^&]+)/;
    const match = otpauthUrl.match(secretRegex);
    return match && match[1];
};

export const makeQRCodeSection = (otpauthUrl: string, size: number = 192) => (
    <div>
        <div style={{ background: 'white', padding: 8, borderRadius: 8, display: 'inline-block' }}>
            <QRCodeCanvas value={otpauthUrl} size={size} bgColor='white' includeMargin />
        </div>
        <br />
        <Typography.Text style={{ fontSize: '12px' }} copyable={{ text: getSecretFromUrl(otpauthUrl) || '' }}>
            {getSecretFromUrl(otpauthUrl)}
        </Typography.Text>
    </div>
);

export const makeTfaSetupComponents = () => (
    <>
        {makeTitleStep1()}
        {makeSubDescriptionStep1()}
        {makeTitleStep2()}
    </>
);
